import React, { useEffect, useRef } from "react";
import styles from "./AverageStars.module.scss";

import { ReactComponent as StarIcon } from "../../assets/images/star-small.svg";

const AverageStars = ({ average, maxScore }) => (
  <div
    className={`${styles.AverageStars} d-flex align-items-center justify-content-center`}
    data-testid="AverageStars"
  >
    {Array.from(new Array(maxScore).keys()).map((_, idx) => (
      <AverageStar key={idx} percentage={average > idx + 1 ? 1 : average - idx} />
    ))}
  </div>
);

const AverageStar = ({ percentage }) => (
  <div className={styles.AverageStarContainer}>
    <div
      data-testid="AverageStar"
      className={styles.AverageStar}
      style={{
        display: percentage > 0 ? "block" : "none",
        marginLeft: percentage > 0 && percentage < 1 ? percentage * 15 - 15 : 0,
      }}
    >
      <Star className={styles.StarIconFilled} percentage={percentage} />
    </div>
    <Star className={styles.StarIcon} />
  </div>
);

const Star = ({ className, percentage = 0 }) => {
  const ref = useRef();

  useEffect(() => {
    if (ref && ref.current) {
      const svg = ref.current;
      const box = svg.getBBox();
      const width =
        percentage > 0 && percentage < 1 ? box.x + box.width * percentage - box.width : box.x;
      const viewBox = [width, box.y, box.width, box.height].join(" ");

      svg.setAttribute("viewBox", viewBox);
    }
  }, [ref, percentage]);

  return <StarIcon className={className} ref={ref} />;
};

AverageStars.propTypes = {};

AverageStars.defaultProps = {};

export default AverageStars;
